<template>
  <section id="curators" ref="curators">
    <div class="spacer">
      <div class="big title ">{{ curators.title }}</div>
      <collapse
        v-for="item in curators.peoples"
        :key="item.title"
        :uid="item.uid"
        parent="curators"
        :fold="true"
      >
        <template v-slot:header>
          <div class="first">{{ item.name }}</div>
        </template>
        <template v-slot:content>
          <div class="grid">
            <div>
              <img v-if="item.image" :src="item.image.url" :alt="item.name" />
            </div>
            <div v-html="item.bio"></div>
          </div>
        </template>
      </collapse>
    </div>
  </section>
</template>

<script>
import API from "@/api/service";
import Collapse from "@/components/Collapse.vue";
export default {
  components: {
    Collapse
  },
  data() {
    return {
      curators: []
    };
  },
  created() {
    API.curators(this.$i18n.locale).then(page => {
      this.curators = page.data.result;
    });
  }
};
</script>

<style lang="scss" scoped></style>
